import { Component, Input } from '@angular/core';
import { TranslationService } from 'src/app/core/translation/translation.service';
import { SurveyJobStatus } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'job-status-badge',
    templateUrl: 'job-status-badge.component.html'
})
export class JobStatusBadgeComponent {
    @Input() status: SurveyJobStatus = SurveyJobStatus.Unknown;

    constructor(private translate: TranslationService) {}

    get statusBadgeClass(): string {
        switch (this.status) {
            case SurveyJobStatus.New:
                return 'status-new';

            case SurveyJobStatus.InProgress:
                return 'status-in-progress';

            case SurveyJobStatus.FieldWorkComplete:
                return 'status-fw-complete';

            case SurveyJobStatus.Closed:
                return 'status-closed';

            case SurveyJobStatus.Blocked:
            case SurveyJobStatus.Unknown:
            default:
                return 'status-unknown';
        }
    }

    get statusDisplay(): string {
        switch (this.status) {
            case SurveyJobStatus.New:
                return this.translate.instant('TC.Common.New');

            case SurveyJobStatus.InProgress:
                return this.translate.instant('TC.Common.Status.InProgress');

            case SurveyJobStatus.FieldWorkComplete:
                return this.translate.instant('Survey.SurveyJobPanel.Badge.FieldWorkComplete');

            case SurveyJobStatus.Closed:
                return this.translate.instant('TC.Common.Status.Closed');

            case SurveyJobStatus.Blocked:
            case SurveyJobStatus.Unknown:
            default:
                return String(this.status) || this.translate.instant('TC.Common.Unknown');
        }
    }
}
